/* dcent-video-facade.js — dcent-component-video-facade 동작.
 *
 * 하는 일 두 가지뿐이다.
 *  1) 유튜브 고해상도 썸네일이 있으면 바꿔 끼운다. 없는 해상도는 404 대신 120x90 회색
 *     이미지를 주므로 naturalWidth 로 판별한다(라이브와 같은 방식).
 *  2) 재생 버튼 클릭 시에만 youtube-nocookie iframe 을 만들어 넣는다.
 *     클릭 전에는 유튜브로 나가는 요청이 0 이다(파사드).
 *
 * 섹션이 여러 번 실릴 수 있으므로 data-dcent-vfacade 를 전수 순회하고, 이미 붙인 노드는
 * 표식으로 건너뛴다(테마 에디터의 섹션 재렌더 대비).
 */

const THUMB_SIZES = ["maxresdefault", "hq720"];

function upgradeThumb(stage, videoId) {
  const img = stage.querySelector(".dcent-vfacade__thumb");
  if (!img) return;

  const tryNext = (index) => {
    if (index >= THUMB_SIZES.length) return;
    const probe = new Image();
    probe.onload = () => {
      // 회색 플레이스홀더(120x90)면 다음 해상도로 넘어간다.
      if (probe.naturalWidth > 320) img.src = probe.src;
      else tryNext(index + 1);
    };
    probe.onerror = () => tryNext(index + 1);
    probe.src = `https://i.ytimg.com/vi/${videoId}/${THUMB_SIZES[index]}.jpg`;
  };

  tryNext(0);
}

function mount(stage) {
  if (stage.dataset.dcentVfacadeReady === "1") return;
  const videoId = stage.getAttribute("data-video");
  if (!videoId) return;
  stage.dataset.dcentVfacadeReady = "1";

  const hl = stage.getAttribute("data-hl") || "en";
  const title = stage.getAttribute("data-title") || "";

  upgradeThumb(stage, videoId);

  stage.addEventListener("click", (event) => {
    if (!event.target.closest("[data-dcent-vfacade-play]")) return;
    const frame = document.createElement("iframe");
    frame.src =
      `https://www.youtube-nocookie.com/embed/${videoId}` +
      `?autoplay=1&rel=0&modestbranding=1&playsinline=1&hl=${encodeURIComponent(hl)}`;
    if (title) frame.title = title;
    frame.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
    frame.setAttribute("allowfullscreen", "");
    stage.innerHTML = "";
    stage.appendChild(frame);
  });
}

function mountAll(root) {
  (root || document).querySelectorAll("[data-dcent-vfacade]").forEach(mount);
}

mountAll();

// 테마 에디터가 섹션을 다시 그리면 새 노드에 다시 붙인다.
document.addEventListener("shopify:section:load", (event) =>
  mountAll(event.target),
);
